import { cn } from "@/shared/lib/utils";
import { branding } from "@/config";

interface LogoProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: "sm" | "md" | "lg";
  showText?: boolean;
}

/**
 * Logo component. Image and text come from branding config (env).
 */
export function Logo({ size = "md", showText = true, className, ...props }: LogoProps) {
  const sizeClasses = {
    sm: "h-8 w-8",
    md: "h-9 w-9",
    lg: "h-11 w-11"
  };

  const textSizeClasses = {
    sm: "text-base",
    md: "text-lg",
    lg: "text-xl"
  };

  return (
    <div className={cn("flex items-center gap-3", className)} {...props}>
      <div className="relative">
        <img
          src={branding.logoPath}
          alt={branding.appTitle}
          className={cn("object-contain drop-shadow-md", sizeClasses[size])}
        />
        <div className="absolute inset-0 bg-visagio-mint/20 blur-lg rounded-full -z-10" />
      </div>

      {showText && (branding.appTitle || branding.appSubtitle) && (
        <div className="flex flex-col leading-tight animate-in fade-in duration-150">
          {branding.appTitle && (
            <span className={cn(
              "font-heading font-bold tracking-tight text-white",
              textSizeClasses[size]
            )}>
              {branding.appTitle}
            </span>
          )}
          {branding.appSubtitle && (
            <span className="text-[10px] text-white/70 font-body font-medium tracking-widest uppercase">
              {branding.appSubtitle}
            </span>
          )}
        </div>
      )}
    </div>
  );
}
